<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" title="CONTENTS">
<h2 class="h2b" id="cont"><a id="page_vii"></a>CONTENTS</h2>
<p class="toc-entry"><a href="#/xhtml/frontmatter01">Preface</a></p>
<p class="toc-entry"><a href="#/xhtml/frontmatter02">Note on Maps</a></p>
<p class="toc-entry"><a href="#/xhtml/frontmatter03">List of Abbreviations</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter01">1. Korea and the Cold War World</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter02">2. Grenade Hill: 3d Battalion, 32d Infantry Regiment, 14–16 March 1951</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter03">3. Breaking the Hongch’on Defense Line: 3d Battalion, 5th Cavalry Regiment, 13–18 March 1951</a></p>
<p class="toc-entry"><span href="#/xhtml/chapter04" title="Link target outside of Sample">4. Supporting the Attack: 3d Battalion, 5th Cavalry Regiment, 13–18 March 1951</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter05" title="Link target outside of Sample">5. Operation Tomahawk: 187th Airborne Regimental Combat Team, 23–24 March 1951</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter06" title="Link target outside of Sample">6. Task Force Growdon: 21–24 March 1951</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter07" title="Link target outside of Sample">7. The Advance East: 187th Airborne Regimental Combat Team, 24–25 March 1951</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter08" title="Link target outside of Sample">8. Cutting the Uijongbu Road: 187th Airborne Regimental Combat Team, 26–28 March 1951</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter09" title="Link target outside of Sample">9. Operation Swing—The Push to the East: 23d Infantry Regiment, 4–8 April 1951</span></p>
<p class="toc-entry"><a id="page_viii"></a><span href="#/xhtml/chapter10" title="Link target outside of Sample">10. Operation Swing—The Thrust North and the “Swing”: 23d Infantry Regiment, 4–14 April 1951</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter11" title="Link target outside of Sample">11. Hwach’on Dam—Attacks in the West: 1st Cavalry Division, 9–10 April 1951</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter12" title="Link target outside of Sample">12. Hwach’on Dam—The Amphibious Assault: 1st Cavalry Division, 10–12 April 1951</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter13" title="Link target outside of Sample">13. The Hant’an River Crossing: 24th Infantry Regiment, 10–12 April 1951</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter02" title="Link target outside of Sample">Notes</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter03" title="Link target outside of Sample">Bibliographical Essay</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter04" title="Link target outside of Sample">Index</span></p>
<p class="linespace"> </p>
<p class="toc-entry"><span href="#/xhtml/chapter09#page_PS1" title="Link target outside of Sample"><em>Photo gallery</em></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?b2774ab8